(function () {
  var root = document.documentElement;
  window.__lrMotion = true;
  if (!root.classList.contains('lr-motion')) return;
  var SEL = [
    '.lr-sec:not(.lr-hero) .lr-eyebrow', '.lr-sec:not(.lr-hero) h2', '.lr-sec:not(.lr-hero) .lr-lead',
    '.lr-pcard', '.lr-step', '.lr-note', '.lr-fcard', '.lr-life > *', '.lr-stats > *', '.lr-timeline > *',
    '.lr-rstep', '.lr-routine__img', '.lr-offer__img', '.lr-offer__card', '.lr-cta__btns',
    '.lr-table tbody tr'
  ].join(',');
  var pending = [];

  function show(el) { el.classList.add('is-in'); }

  // Reveal anything that is in (or above) the viewport. Used as the primary check on scroll and as a backstop to IntersectionObserver.
  var queued = false;
  function sweep() {
    queued = false;
    var limit = window.innerHeight * 0.94;
    pending = pending.filter(function (el) {
      if (el.getBoundingClientRect().top < limit) { show(el); return false; }
      return true;
    });
    if (!pending.length) {
      document.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', onScroll);
    }
  }
  function onScroll() { if (!queued) { queued = true; setTimeout(sweep, 50); } }

  function init() {
    pending = Array.prototype.slice.call(document.querySelectorAll(SEL));
    pending.forEach(function (el) {
      var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(SEL); });
      var i = sibs.indexOf(el);
      if (sibs.length > 1 && i > 0) el.style.setProperty('--lr-d', Math.min(i * 0.09, 0.5) + 's');
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
      pending.forEach(function (el) { io.observe(el); });
    }
    // capture: catches scrolling of the window AND of any inner scroll container the theme uses
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', onScroll);
    sweep();
  }

  // Pages can be prerendered by the browser; start once the page is actually shown.
  if (document.prerendering) {
    document.addEventListener('prerenderingchange', init, { once: true });
  } else {
    init();
  }
})();
